import React from 'react';
import styles from './FilterBar.module.css';
import Search from '../Inputs/Search/Search';
import Button from '../Inputs/Button/Button';
import Tooltip from '../Inputs/Tooltip/Tooltip';
import Field from '../Field';
import { FunnelX } from 'lucide-react';

export default function FilterBar({
    filters = [],
    search,
    prefix = "Filter by:",
    className,
}) {
    const clearAll = () => {
        filters.forEach((f) => {
            if (f.type === 'daterange' && f.onMultiChange) {
                f.onMultiChange({ start: '', end: '' });
            } else if (f.onChange) {
                f.onChange(f.allValue ?? 'All');
            }
        });
    };

    return (
        <div className={`${styles.bar} ${className || ''}`}>
            <div className={styles.prefixRow}>
                <span className={styles.prefixText}>{prefix}</span>
            </div>

            <div className={styles.left}>
                {filters.map((f) => (
                    <div className={styles.filterGroup} key={f.key}>
                        <span className={styles.label}>{f.label}</span>
                        <Field
                            cfg={f}
                            value={f.value}
                            onChange={f.onChange}
                            options={f.options || []}
                        />
                    </div>
                ))}
                <Tooltip content="Clear Filters">
                    <Button
                        variant="secondary"
                        shape="square"
                        leadingIcon={<FunnelX size={18} />}
                        onClick={clearAll}
                    />
                </Tooltip>
            </div>

            {search && (
                <div className={styles.right}>
                    <Search
                        label={search.label}
                        value={search.value}
                        onChange={search.onChange}
                    />
                </div>
            )}
        </div>
    );
}
